import React from "react";
import styles from './Header.module.css'
import { NavLink, useNavigate } from "react-router-dom";

export default function Header(){

    const navigate = useNavigate();

    const handleNavigate = (path) => {
        window.scrollTo(0,0);
        navigate(path)
    }

    if(window.innerWidth < window.innerHeight){
        return (
            <header>
                <nav>
                    <ul>
                        <li><NavLink target="_top" to={'/home'}>Home</NavLink></li>
                        {/* <li><NavLink target="_top" to={'/cv'}>CV</NavLink></li> */}
                        <li><NavLink target="_top" to={'/gallery'} >Gallery</NavLink></li>
                        {/* <li><NavLink target="_top" to={'/contact'}>Contact</NavLink></li> */}
                    </ul>
                </nav>
            </header>
        )
    } else {
        return (
            <header>
                <nav>
                    <ul>
                        <li><NavLink target="_top" to={'/home'}>Home</NavLink></li>
                        {/* <li><NavLink target="_top" to={'/cv'}>CV</NavLink></li> */}
                        <li><NavLink target="_top" to={'/gallery'} >Gallery</NavLink></li>
                        {/* <li><NavLink target="_top" to={'/contact'}>Contact</NavLink></li> */}
                    </ul>
                </nav>
            </header>
        )
    }
}